import { LocalOverrideAdapter } from '@statsig/js-local-overrides';

import getClientKey from './utils/getClientKey';

let overrideAdapter: LocalOverrideAdapter | null = null;

/**
 * Returns the singleton LocalOverrideAdapter for the current client key.
 * Only created in browser; returns null during SSR so callers can omit overrideAdapter from client options.
 */
const getStatsigOverrideAdapter = (): LocalOverrideAdapter | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  if (overrideAdapter === null) {
    const clientKey = getClientKey();
    overrideAdapter = new LocalOverrideAdapter(clientKey);
  }

  return overrideAdapter;
};

export default getStatsigOverrideAdapter;
